import React from 'react'
import { BareHighlight } from 'react-fast-highlight'
import hljs from 'highlight.js/lib/highlight'
import xml from 'highlight.js/lib/languages/xml'

import styles from './highlight.jcss'

hljs.registerLanguage('xml', xml)

export interface HighlightProps {
    content: string
    languages: string[]
}

const Highlight = (p_: HighlightProps) => (
    <div className={styles.wrapper}>
        <BareHighlight languages={p_.languages} highlightjs={hljs}>
            {p_.content}
        </BareHighlight>
    </div>
)

Highlight.defaultProps = {
    languages: ['xml'],
}

export default Highlight
